/**
 * format.ts — Small display helpers shared by the screens (H01+).
 */

/** Formats integer cents as a plain decimal amount (locale-neutral). */
export function formatBudgetCents(cents: number): string {
  return (cents / 100).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
